"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.howAppIsRunning = exports.findOutEnv = exports.ENV_URLS = void 0;
var ENV_URLS = [{
  name: 'qa',
  host: 'col10mgmt.tsm.inet',
  custo: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true
    }
  }
}, {
  name: 'qa',
  host: 'qa.cms.col.movistar.es',
  custo: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true
    }
  }
}, {
  name: 'qa',
  host: 'tcolgranja1.es.telefonica',
  custo: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true
    }
  }
}, {
  name: 'qa',
  host: 'tcolgranja2.es.telefonica',
  custo: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true
    }
  }
}, {
  name: 'dev',
  host: '127.0.0.1:8089',
  custo: {
    endpoint: 'https://customizer-dot-mov-dev15.appspot.com',
    headers: {}
  }
}, {
  name: 'prod',
  host: 'prod.cms.col.movistar.es',
  custo: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
      withCredentials: true
    }
  }
}, {
  name: 'prod',
  host: 'www.movistar.es',
  custo: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
      withCredentials: true
    }
  }
}, {
  name: 'prod',
  host: 'atencionalcliente.movistar.es',
  custo: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
      withCredentials: true
    }
  }
}, {
  name: 'prod',
  host: 'web.movistar.es',
  custo: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
      withCredentials: true
    }
  }
}];
exports.ENV_URLS = ENV_URLS;

var findOutEnv = function findOutEnv() {
  var defaultEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'name';
  var res = ENV_URLS.find(function (item) {
    return item.name === defaultEnv;
  });

  try {
    var myUrl = document.location.href;
    var item = ENV_URLS.find(function (envUrl) {
      var host = envUrl.host;
      return myUrl.indexOf(host) !== -1;
    });

    if (item) {
      res = item;
    }
  } catch (err) {
    return res;
  }

  return res;
};

exports.findOutEnv = findOutEnv;

var howAppIsRunning = function howAppIsRunning() {
  var NODE_ENV = process.env.NODE_ENV;
  return NODE_ENV;
};

exports.howAppIsRunning = howAppIsRunning;

//# sourceMappingURL=index.js.map